import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { EditorButtonConfiguration } from '@pt/pt-models';
import { WidgetUtils } from '../../widgets/widget.utils';

@Component({
  selector: 'pt-editor-sidebar-text',
  template: `
    <div class='editor-sidebar-text mb-2'>
      <label [htmlFor]='id' [innerHTML]='label'></label>
      <div class='action'>
        <pt-widget-action
          actionStyle='TEXT'
          [showCancel]='editorButton?.showCancel'
          [showEdit]='editorButton?.showEdit'
          [showLoader]='false'
          [showReload]='false'
          [showSave]='editorButton?.showSave'
          [showIcon]='false'

          [disabledEdit]='editorButton?.disabledEdit'
          [disabledSave]='editorButton?.disabledSave'
          [disabledCancel]='editorButton?.disabledCancel'

          (clickEdit)='clickEdit.emit()'
          (clickCancel)='clickCancel.emit()'
          (clickSave)='clickSave.emit(currentValue)'>
        </pt-widget-action>
      </div>

      <input type='text'
             *ngIf="maxLength"
             autocomplete='off'
             class='form-control form-control-sm'
             [readOnly]='!editorButton?.showSave'
             [(ngModel)]='currentValue'
             [ngClass]="{'text-black': !editorButton?.disabledSave}"
             [maxLength]="maxLength"
             [id]='id'>
      <input type='text'
             *ngIf="!maxLength"
             autocomplete='off'
             class='form-control form-control-sm'
             [readOnly]='!editorButton?.showSave'
             [(ngModel)]='currentValue'
             [ngClass]="{'text-black': !editorButton?.disabledSave}"
             [id]='id'>
      <div *ngIf="maxLength && editorButton?.showSave" class="form-text" style="text-align: right">{{currentValue?.length || 0}}/{{maxLength}}</div>
    </div>
  `,
  styles: [
    `
      .editor-sidebar-text {
        margin-bottom: 0;
      }

      .editor-sidebar-text .text-black {
        color: #495057 !important;
        opacity: 1 !important;
      }

      .editor-sidebar-text .action {
        float: right;
        margin-top: 3px;
      }

      .editor-sidebar-text label {
        margin-bottom: 2px;
        margin-top: 5px;
      }

      .editor-sidebar-text input {
        height: 25px;
        padding: 0;
        line-height: 1;
        border-radius: 0;
        border-top: 0;
        border-left: 0;
        border-right: 0;
        font-weight: bold;
        color: #000000;
      }

      .editor-sidebar-text .form-control:disabled, .form-control[readonly] {
        background-color: #ffffff !important;
        opacity: .7;
      }

      .editor-sidebar-text .form-control:disabled, .form-control[readonly]:focus {
        border-color: #dfdfdf;
        box-shadow: none;
      }
    `
  ]
})
export class EditorSidebarTextComponent implements OnChanges {
  @Input() label: string;
  @Input() value: string;
  @Input() editorButton: EditorButtonConfiguration;
  @Input() maxLength?: number;

  currentValue: string;

  @Output() clickEdit = new EventEmitter();
  @Output() clickSave = new EventEmitter<string>();
  @Output() clickCancel = new EventEmitter();

  id: string;

  constructor() {
    this.id = WidgetUtils.generateId('est_');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value) {
      this.currentValue = changes.value.currentValue;
    }
  }
}
